import { render, staticRenderFns } from "./swiper_new_videos.vue?vue&type=template&id=2edf4018"
import script from "./swiper_new_videos.vue?vue&type=script&lang=js"
export * from "./swiper_new_videos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports